<div class="documents-page" data-testid="documents-page">
  <div class="page-header">
    <h1 class="page-header__title">Licenses</h1>
    <p class="page-header__subtitle">
      Upload and manage your licenses required for each of your coverage zones.
    </p>
  </div>

  <!-- Approach A (requirement-led): per zone, one row per service /
       sub-service that requires a document, with the covering document (or
       an Upload CTA) on the right; then an Additional documents bucket.
       The requirement rows/cards/dialogs are the SHARED zone-documents
       components in vendor mode — the internal Users console renders the
       same building blocks in internal mode. -->
  <section
    class="doc-panel"
    *ngFor="let serviceZone of user.serviceZones"
    [attr.data-testid]="'documents-zone-' + zoneTestKey(serviceZone)"
  >
    <div class="doc-zone__header">
      <h3 class="doc-panel__title">
        {{
          serviceZone.nationwide
            ? "Nationwide"
            : decodeState(serviceZone.state)
        }}
      </h3>
      <p class="doc-zone__summary" *ngIf="zoneHasDocNodes(serviceZone)">
        <ng-container
          *ngIf="
            zoneRequiredCount(serviceZone) === 0 &&
              zoneUnderReviewCount(serviceZone) === 0;
            else zoneDocCounts
          "
        >
          All Licenses on File
        </ng-container>
        <ng-template #zoneDocCounts>
          {{ zoneRequiredLabel(serviceZone) }} ·
          {{ zoneUnderReviewLabel(serviceZone) }}
        </ng-template>
      </p>
    </div>

    <zone-doc-requirements
      [serviceZone]="serviceZone"
      mode="vendor"
      [licenseRequirements]="applicableLicenses"
      [serviceTypeIdToType]="serviceTypeIdToType"
      (upload)="
        openZoneDocUpload(
          $event.serviceZone,
          $event.service,
          $event.subType,
          $event.license
        )
      "
      (editCoverage)="openEditDocDialog($event.serviceZone, $event.document)"
      (preview)="openPdfViewer($event)"
      (download)="downloadDocument($event)"
      (delete)="deleteZoneDocument($event.serviceZone, $event.document.id)"
    ></zone-doc-requirements>
  </section>

  <!-- Empty state — no coverage zones configured yet. -->
  <div
    class="empty-state doc-empty-zones"
    *ngIf="!(user?.serviceZones && user.serviceZones.length > 0)"
    data-testid="documents-zones-empty"
  >
    <p>No coverage zones yet.</p>
    <p class="doc-empty-zones__hint">
      Add a coverage zone under Services &amp; Zones to see the documents required
      there.
    </p>
  </div>
</div>

<!-- Shared single-file zone-document upload dialog (drop zone + inline preview +
     coverage form). The host owns the per-node context; the dialog owns the
     file/preview UI and emits the file + coverage on save. -->
<zone-doc-upload-dialog
  *ngIf="zoneDocUploadOpen"
  [zoneLabel]="
    zoneDocUploadZone?.nationwide
      ? 'Nationwide'
      : decodeState(zoneDocUploadZone?.state)
  "
  [service]="zoneDocUploadService"
  [scopedSubType]="zoneDocUploadSubType"
  [siblings]="zoneDocUploadSiblings"
  [license]="zoneDocUploadLicense"
  [hasServiceLevelNode]="zoneDocUploadHasServiceLevelNode"
  [submitting]="zoneDocUploadSubmitting"
  (save)="saveZoneDocUpload($event)"
  (cancelled)="cancelZoneDocUpload()"
></zone-doc-upload-dialog>
<!-- Shared edit / link zone-document coverage dialog (coverage form only). -->
<zone-doc-edit-dialog
  *ngIf="editDocOpen"
  [zoneLabel]="
    editDocZone?.nationwide ? 'Nationwide' : decodeState(editDocZone?.state)
  "
  [document]="editDocDocument"
  [serviceZone]="editDocZone"
  [serviceTypeIdToType]="serviceTypeIdToType"
  [selectableLicenses]="editDocSelectableLicenses"
  [initialServiceType]="editDocInitialServiceType"
  [initialSubTypes]="editDocInitialSubTypes"
  [initialExpiration]="editDocInitialExpiration"
  [initialIssueDate]="editDocInitialIssueDate"
  [initialLicenseRequirementId]="editDocInitialLicenseRequirementId"
  [submitting]="editDocSubmitting"
  (save)="saveEditDoc($event)"
  (cancelled)="cancelEditDoc()"
></zone-doc-edit-dialog>
